import { createSlice } from "@reduxjs/toolkit";

export const name = "android";

export const androidSlice = createSlice({
  name,
  initialState: {
    crimes: [],
    crimesLoading: false,
    permissions: [],
    permissionsLoading: false,
    plugins: {},
    pluginsLoading: false,
    apkInfo: {},
    apkInfoLoading: false,
    additionalDetails: {},
    additionalDetailsLoading: false,
    staticCodeIssues: {},
    staticCodeIssuesLoading: false,
  },
  reducers: {
    RequestCrimes: (state) => {
      state.crimesLoading = true;
      state.crimes = [];
    },
    SuccessCrimes: (state, action) => {
      state.crimes = action.payload;
      state.crimesLoading = false;
    },
    FailureCrimes: (state) => {
      state.crimes = [];
      state.crimesLoading = false;
    },
    RequestPermissions: (state) => {
      state.permissionsLoading = true;
    },
    SuccessPermissions: (state, action) => {
      state.permissions = action.payload;
      state.permissionsLoading = false;
    },
    FailurePermissions: (state) => {
      state.permissions = [];
      state.permissionsLoading = false;
    },
    RequestPlugins: (state) => {
      state.pluginsLoading = true;
    },
    SuccessPlugins: (state, action) => {
      state.plugins = action.payload;
      state.pluginsLoading = false;
    },
    FailurePlugins: (state) => {
      state.plugins = {};
      state.pluginsLoading = false;
    },
    RequestApkInfo: (state) => {
      state.apkInfoLoading = true;
    },
    SuccessApkInfo: (state, action) => {
      state.apkInfo = action.payload;
      state.apkInfoLoading = false;
    },
    FailureApkInfo: (state) => {
      state.apkInfo = {};
      state.apkInfoLoading = false;
    },
    RequestAndroidAdditionalDetails: (state) => {
      state.additionalDetailsLoading = true;
    },
    SuccessAndroidAdditionalDetails: (state, action) => {
      state.additionalDetails = action.payload;
      state.additionalDetailsLoading = false;
    },
    FailureAndroidAdditionalDetails: (state) => {
      state.additionalDetails = {};
      state.additionalDetailsLoading = false;
    },
    RequestStaticCodeIssues: (state) => {
      state.staticCodeIssuesLoading = true;
    },
    SuccessStaticCodeIssues: (state, action) => {
      state.staticCodeIssues = action.payload;
      state.staticCodeIssuesLoading = false;
    },
    FailureStaticCodeIssues: (state) => {
      state.staticCodeIssues = {};
      state.staticCodeIssuesLoading = false;
    },
  },
});

export default androidSlice;
